// extracted by mini-css-extract-plugin
export default {"form":"VacancyApplyForm_form__VxJag","title":"VacancyApplyForm_title__C34lY","sliceBorder":"VacancyApplyForm_sliceBorder__nth1m"};